<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <div class="row" v-for="(item, key) in items" :key="key">
        <div
          class="col-md-12 pt-0 pb-0 c-warning text-center"
          v-if="item.resident_account"
        >
          LANÇAMENTO FATURADO
        </div>
        <div class="col-md-6 pt-0 pb-0 d-flex">
          <label class="mr-1">Descrição:</label>
          <p>{{ item.description }}</p>
        </div>
        <div class="col-md-3 pt-0 pb-0 d-flex">
          <p v-if="item.spent_or_gain == 'DEBITO'">DÉBITO</p>
          <p v-if="item.spent_or_gain == 'CREDITO'">CRÉDITO</p>
        </div>
        <div class="col-md-3 pt-0 pb-0 d-flex">
          <label class="mr-1">Valor:</label>
          <p
            :class="[
              item.spent_or_gain == 'DEBITO' && 'c-danger',
              item.spent_or_gain == 'CREDITO' && 'c-success',
            ]"
          >
            {{ item.value }}
          </p>
        </div>
        <div
          v-if="data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Categoria:</label>
          <p>
            {{ item.finance_configuration_category_name }}
          </p>
        </div>
        <div class="col-md-6 pt-0 pb-0 d-flex">
          <label class="mr-1">Centro de custo/lucro:</label>
          <p>
            {{
              item.finance_configuration_profit_cost_center_description
                ? item.finance_configuration_profit_cost_center_description
                : "Não informado!"
            }}
          </p>
        </div>
        <div
          v-if="item.spent_or_gain == 'DEBITO' && data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Fornecedor:</label>
          <p>
            {{
              item.provider_company_name
                ? item.provider_company_name
                : "Não informado!"
            }}
          </p>
        </div>
        <div
          v-if="item.spent_or_gain == 'CREDITO' && data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Cliente:</label>
          <p>
            {{
              item.finance_client_name
                ? item.finance_client_name
                : "Não informado!"
            }}
          </p>
        </div>
        <div
          v-if="data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Forma de pagamento:</label>
          <p>
            {{
              item.finance_configuration_payment_methods_description
                ? item.finance_configuration_payment_methods_description
                : "Não informado!"
            }}
          </p>
        </div>
        <div
          v-if="data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Tipo de custo:</label>
          <p>{{ item.cost_type ? item.cost_type : "Não informado!" }}</p>
        </div>
        <div
          v-if="data.type != 'TRANSFERENCIA'"
          class="col-md-6 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Apropriação de custo:</label>
          <p>
            {{
              item.cost_appropriation
                ? item.cost_appropriation
                : "Não informado!"
            }}
          </p>
        </div>
        <div
          v-if="data.type != 'TRANSFERENCIA'"
          class="col-md-12 pt-0 pb-0 d-flex"
        >
          <label class="mr-1">Tags:</label>
          <div class="d-flex">
            <p v-if="item.tags.length == 0">Não informado!</p>
            <p v-for="(tag, key) in item.tags" :key="key" class="m-0 mr-2">
              {{ tag.description }};
            </p>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

export default {
  name: "Details",
  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      finance_configuration_account_id: "",
      due_date: "",
      finance_configuration_document_types_id: "",
      how_many_times: "",
      document_number: "",
      competence: "",
      note: "",
      paid_in_date: "",
      periodicity: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,
      items: [],
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    retrieve() {
      let { data, finance_configuration_tag } = this;

      for (let item of data.items) {
        if (item.spent_or_gain == "DEBITO") {
          item.value = formatValueNegativeOnKeyUp(item.value);
        } else {
          item.value = formatValueOnKeyUp(item.value);
        }

        let tags = [];

        if (item.finance_configuration_tag_ids) {
          for (let tag_id of item.finance_configuration_tag_ids) {
            for (let tag of finance_configuration_tag) {
              if (tag_id == tag.id) {
                tags.push(tag);
              }
            }
          }
        }

        this.items.push({
          id: item.id,
          description: item.description,
          value: item.value,
          finance_configuration_category_id:
            item.finance_configuration_category_id,
          finance_configuration_profit_cost_center_id:
            item.finance_configuration_profit_cost_center_id,
          provider_id: item.provider_id,
          finance_client_id: item.finance_client_id,
          finance_configuration_payment_methods_id:
            item.finance_configuration_payment_methods_id,
          finance_configuration_tag_ids: item.finance_configuration_tag_ids,
          cost_type: item.cost_type,
          cost_appropriation: item.cost_appropriation,
          spent_or_gain: item.spent_or_gain,
          finance_configuration_category_name:
            item.finance_configuration_category_name,
          finance_configuration_profit_cost_center_description:
            item.finance_configuration_profit_cost_center_description,
          provider_company_name: item.provider_company_name,
          provider_cpf_cnpj: item.provider_cpf_cnpj,
          finance_client_name: item.finance_client_name,
          finance_configuration_payment_methods_description:
            item.finance_configuration_payment_methods_description,
          tags,
          resident_account: item.resident_account,
        });
      }
    },
  },
};
</script>